import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8" }
const _hoisted_2 = {
  key: 0,
  class: "max-w-lg mx-auto"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Password Reset", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "text-red-400"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold text-green-400" }, " Success! Redirecting you in just a moment ", -1)
const _hoisted_9 = [
  _hoisted_8
]

import { computed, ref } from "vue";
import router from "@/router";
import { HoodApi } from "@/services/HoodApi";

export default /*#__PURE__*/_defineComponent({
  props: {
  token: {
    type: String,
  },
},
  setup(__props) {

const props = __props



const loading = ref(false);

const password = ref("");
const password_again = ref("");
const my_token = computed(() => String(router.currentRoute.value.query.token));
const errorMsg = ref("");
const success = ref(false);
const reset_password = async () => {
  try {
    loading.value = true;
    if (my_token.value && password.value === password_again.value) {
      const response = await HoodApi.change_password(
        password.value,
        my_token.value
      );
      console.log(response.status);
      if (response.status === "OK") {
        success.value = true;
        setTimeout(() => {
          router.push("/login");
        }, 2000);
        // router.push("login");
      }
      loading.value = false;
    } else {
      if (my_token.value === null) {
        errorMsg.value = "Reset Token Has Expired. Request a new one";
      } else if (password.value !== password_again.value) {
        errorMsg.value = "Passwords do not match";
      }
      loading.value = false;
    }
  } catch (error) {
    console.log(error);
    errorMsg.value = "Network Error";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!success.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", null, _toDisplayString(_unref(my_token)), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Enter new password",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
            class: "w-full p-4 pr-12 text-sm border-gray-400 rounded-lg shadow-sm mb-4"
          }, null, 512), [
            [_vModelText, password.value]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Confirm New Password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password_again).value = $event)),
            class: "w-full p-4 pr-12 text-sm border-gray-400 rounded-lg shadow-sm mb-4"
          }, null, 512), [
            [_vModelText, password_again.value]
          ]),
          (loading.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Working on it..."))
            : _createCommentVNode("", true),
          (errorMsg.value !== '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errorMsg.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            disabled: loading.value,
            onClick: reset_password,
            class: "block w-3/4 px-5 py-3 text-sm font-medium text-white bg-indigo-600 rounded-lg"
          }, " Update Password ", 8, _hoisted_6)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
  ]))
}
}

})